// extracted by mini-css-extract-plugin
export default {"link":"FormatedElement-module--link--MRlYC","link-icon":"FormatedElement-module--link-icon--b8-rW","p":"FormatedElement-module--p--78R+K"};